import { css } from '@emotion/core'
import { Cell, Grid, PersonBlock } from '@fs/zion-ui'
import React from 'react'

const contentPadding = css`
  padding-top: 16px;
  padding-inline-end: 16px;
  padding-bottom: 8px;
  padding-inline-start: 16px;
`

export default function Intro({ details }) {
  const getPersonDetails = () => {
    if (details.birthDate && details.deathDate) {
      return `${details.birthDate} - ${details.deathDate} • ${details.personId}`
    }
    return `${details.lifespan} • ${details.personId}`
  }
  return (
    <div css={contentPadding}>
      <Grid>
        <Cell columns={6}>
          <PersonBlock
            size="lg"
            avatarProps={{
              sex: details.gender,
            }}
            name={details.name}
            details={getPersonDetails()}
          />
        </Cell>
      </Grid>
    </div>
  )
}
